/* Hero dots. Position is read from IntersectionObserver, never from a
   scroll handler, so the hero costs nothing on the main thread. */
(function () {
  document.querySelectorAll('.pm-hero').forEach(function (hero) {
    var rail = hero.querySelector('[data-pm-hero-rail]');
    var dots = hero.querySelector('[data-pm-hero-dots]');
    if (!rail || !dots) return;

    var slides = Array.prototype.slice.call(rail.children);
    var buttons = Array.prototype.slice.call(dots.children);

    var mark = function (index) {
      buttons.forEach(function (btn, i) {
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        rail.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio > 0.6) mark(slides.indexOf(entry.target));
        });
      },
      { root: rail, threshold: [0.6] }
    );
    slides.forEach(function (slide) {
      observer.observe(slide);
    });

    mark(0);
  });
})();
